import {Component, OnInit} from '@angular/core';
import {Chunker} from '../framework/chunker';
import {FrameworkHttpService} from '../framework/http/service';
import {MappingSystemUser2SORUserEntity, QARService, SORUserEntity} from '../services/qar.service';
import {Observable, of} from 'rxjs';
import {FormControl} from '@angular/forms';
import {debounceTime, map, startWith, switchMap} from 'rxjs/operators';
import {UITableComponentHeader, UITableComponentOptions} from '../framework/ui/table';

@Component({
	selector: 'app-page-sor-mapping-inactive',
	template: `
	    <ui-title [title]="'Users Inactive (in AD)'"></ui-title>
	    <ui-loading [loading]="inactive.loading" [loadingText]="'loading users'"></ui-loading>

	    <div class="card">
		    <div class="card-header">
			    Users
		    </div>
		    <div class="card-body  col-lg-6">
			    <table class="table table-sm mb-0">
				    <thead>
				    <th>User Name in System</th>
				    <th>User Full Name</th>
				    <th>User Email</th>
				    </thead>
				    <tbody>
				    <tr *ngFor="let row of inactive.users">
					    <td>{{row.UserName}}</td>
					    <td>{{row.SORUser.FirstName}} {{row.SORUser.LastName}}</td>
					    <td>{{row.SORUser.Email}}</td>
				    </tr>
				    </tbody>
			    </table>
		    </div>
		    <div class="card-body">
			    <ui-table [chunker]="inactive.chunkerUsers" (chunked)="inactive.chunkedDataUsers = $event" [headers]="inactive.tableHeaders"
				      [filters]="true">
				    <tr *ngFor="let sbr of inactive.chunkedDataUsers"
				    >
					    <td>{{sbr.SystemRole.System.Name}}</td>
					    <td>{{sbr.UserName}}</td>
					    <td>{{sbr.RoleName}}</td>
					    <td>{{sbr.Id}}</td>
					    <td>{{sbr.SORUser.FirstName}} {{sbr.SORUser.LastName}}</td>
					    <td>{{sbr.SORUser.Login}}</td>
					    <td>{{sbr.SORUser.UserPrincipalName}}</td>
				    </tr>
			    </ui-table>
		    </div>
	    </div>

	    <div class="card-separator"></div>

	    <div class="card">
		    <div class="card-header">
			    Approvers
		    </div>
		    <div class="card-body col-lg-6">
			    <table class="table table-sm mb-0">
				    <thead>
				    <th>Manager Full Name</th>
				    <th>Manager Email</th>
				    </thead>
				    <tbody>
				    <tr *ngFor="let manager of inactive.managers">
					    <td>{{manager.FirstName}} {{manager.LastName}}</td>
					    <td>{{manager.Email}}</td>
				    </tr>
				    </tbody>
			    </table>
		    </div>
		    <div class="card-body">
			    <ui-table [chunker]="inactive.chunkerManagers" (chunked)="inactive.chunkedDataManagers = $event" [headers]="inactive.tableHeadersManagers"
				      [filters]="true">
				    <tr *ngFor="let sbr of inactive.chunkedDataManagers"
				    >
					    <td>{{sbr.SystemRole.System.Name}}</td>
					    <td>{{sbr.UserName}}</td>
					    <td>{{sbr.RoleName}}</td>
					    <td>{{sbr.Id}}</td>
					    <td>{{(sbr.SORUser.OverridenManager ? sbr.SORUser.OverridenManager : sbr.SORUser.Manager).FirstName}} {{(sbr.SORUser.OverridenManager ? sbr.SORUser.OverridenManager : sbr.SORUser.Manager).LastName}}</td>
					    <td>{{(sbr.SORUser.OverridenManager ? sbr.SORUser.OverridenManager : sbr.SORUser.Manager).Login}}</td>
					    <td>{{(sbr.SORUser.OverridenManager ? sbr.SORUser.OverridenManager : sbr.SORUser.Manager).UserPrincipalName}}</td>
				    </tr>
			    </ui-table>
		    </div>
	    </div>
	`,
	providers: [QARService]
})
export class SorUserInactiveHomeComponent implements OnInit {


	constructor(public api: QARService) {
	}

	public inactive = {
		loading: true,
		users: [],
		managers: [],
		chunkedDataUsers: [],
		chunkedDataManagers: [],
		chunkerUsers: new Chunker([]),
		chunkerManagers: new Chunker([]),
		tableHeaders: [
			{label: 'System', filterable: true, idFunction: this.helper_idFunction_System},
			{label: 'User Name in System', filterable: true, id: 'UserName'},
			{label: 'Role Name', filterable: true, id: 'RoleName'},
			{label: 'Row ID', filterable: true, id: 'Id'},
			{label: 'User Name', filterable: true, idFunction: this.helper_idFunction_UserName},
			{label: 'User Login', filterable: true, idFunction: this.helper_idFunction_UserLogin},
			{label: 'User UPN', filterable: true, idFunction: this.helper_idFunction_UserUPN},
		] as UITableComponentHeader[],
		tableHeadersManagers: [
			{label: 'System', filterable: true, idFunction: this.helper_idFunction_System},
			{label: 'Manager Name in System', filterable: true, id: 'UserName'},
			{label: 'Role Name', filterable: true, id: 'RoleName'},
			{label: 'Row ID', filterable: true, id: 'Id'},
			{label: 'Manager Name', filterable: true, idFunction: this.helper_idFunction_UserName},
			{label: 'Manager Login', filterable: true, idFunction: this.helper_idFunction_UserLogin},
			{label: 'Manager UPN', filterable: true, idFunction: this.helper_idFunction_UserUPN},
		] as UITableComponentHeader[]
	};

	public helper_idFunction_System(a) {
		return a.SystemRole.System.Name;
	}

	public helper_idFunction_UserName(a) {
		return a.SORUser.FirstName + ' ' + a.SORUser.LastName;
	}

	public helper_idFunction_UserLogin(a) {
		return a.SORUser.Login;
	}

	public helper_idFunction_UserUPN(a) {
		return a.SORUser.UserPrincipalName;
	}

	public ngOnInit(): void {
		this.api.retrieveInactiveUsers().then(r => {
			this.inactive.chunkerUsers = new Chunker(r['users']);
			this.inactive.chunkerManagers = new Chunker(r['approvers']);
			let existingUsers = [];
			for (const user of r['users']) {
				if (existingUsers.indexOf(user.SORUser.UserPrincipalName) === -1) {
					existingUsers.push(user.SORUser.UserPrincipalName);
					this.inactive.users.push(user);
				}
			}
			existingUsers = [];
			for (const row of r['approvers']) {
				const approver = row.SORUser.OverridenManager ? row.SORUser.OverridenManager : row.SORUser.Manager;
				if (existingUsers.indexOf(approver.UserPrincipalName) === -1) {
					existingUsers.push(approver.UserPrincipalName);
					this.inactive.managers.push(approver);
				}
			}
			this.inactive.loading = false;
		});
	}


}
